export const LOCALSTORAGE_KEYS = {
  previousClinic: 'previousClinic',
};
